export const STATIC_ASSETS_URL =
  process.env.NODE_ENV !== 'production'
    ? 'https://dev.epilot.cloud/elements-static'
    : 'https://go.epilot.cloud/elements-static'
